
(function inicioControllerDefinition() {

    'use strict';

    angular.module('Inicio')
        .controller('InicioOuController', ['auth',
            'authExtend', '$scope', 'config', '$state', '$stateParams', 'errorsExtend', 'loginService', 'urlstate',
            function inicioController(auth, authExtend, $scope, config, $state, $stateParams, errors, loginService, urlstate) {
                $scope.isLogged = false;

                $scope.redirect = function () {

                    if (authExtend.getOrganizationId() === $stateParams.ouId) {
                        $state.go(urlstate, { id: $stateParams.id });
                    } else {
                        $scope.setOu($stateParams.ouId).then(function ()
                        {                           
                            $state.go(urlstate, { id: $stateParams.id });
                        }, function (error) {
                            $state.go('inicio');
                        });                        
                    }
                };

                $scope.setOu = function (ouId) {                    
                  return loginService.setUserOu(ouId).then(function (result) {
                      return auth.refreshToken().then(function (result) {    
                            if (!result) {
                                login.logOut();
                                return;
                            }
                        },
                           function () {
                                login.logOut();
                            });
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.redirect();
            }


        ]);
})();
